import React from 'react';
import { X } from 'lucide-react';
import DownloadButtons from './DownloadButtons';
import { useLanguage } from '../context/LanguageContext';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DownloadModal: React.FC<DownloadModalProps> = ({ isOpen, onClose }) => {
  const { language } = useLanguage();
  const isEnglish = language === 'en';
  React.useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full mx-auto overflow-hidden transform transition-all duration-300 animate-in fade-in-0 zoom-in-95 slide-in-from-bottom-4">
        {/* Header avec bouton fermer */}
        <div className="flex justify-between items-center p-6 border-b border-gray-100">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-[#fc2207] to-[#fe5801] bg-clip-text text-transparent">
            {isEnglish ? 'Download Burok' : 'Télécharger Burok'}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
            aria-label={isEnglish ? 'Close modal' : 'Fermer le modal'}
            title={isEnglish ? 'Close modal' : 'Fermer le modal'}
          >
            <X className="w-6 h-6 text-gray-500" />
          </button>
        </div>

        {/* Contenu du modal */}
        <div className="p-8 text-center">
                     {/* QR Code */}
           <div className="mb-8">
             <div className="inline-block p-4 bg-white rounded-2xl shadow-lg border-4 border-gray-100">
               <div className="w-48 h-48 bg-white rounded-xl flex items-center justify-center p-2">
                 <img 
                   src="/assets/qrcodefake.png" 
                   alt="QR Code Burok" 
                   className="w-full h-full object-contain rounded-lg"
                 />
               </div>
             </div>
           </div>

          {/* Description */}
          <p className="text-gray-600 mb-8 text-lg">
            {isEnglish
              ? 'Scan the QR code with your phone or use the buttons below'
              : 'Scannez le QR code avec votre téléphone ou utilisez les boutons ci-dessous'}
          </p>

          {/* Boutons de téléchargement */}
          <div className="space-y-4">
            <DownloadButtons />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
